module.exports = __webpack_public_path__ + "static/media/kz.78345683.svg";